import { defineMessage } from 'react-intl';

export const gipReportDateRangeExceededMessage = defineMessage({
  id: 'audit.gipReport.error.dateRangeExceeded',
  defaultMessage: 'El rango de fechas no puede superar los {maxDays} días.',
});
